<template>
<div class="md:grid md:grid-cols-2 xl:flex xl:flex-col">
    <Card v-for="trophy in trophies" :key="trophy.id" :trophy="trophy" />
</div>
</template>

<script>
import Card from '@/components/Home/KPIS/Cards/Format-2.vue'

export default {
    components: {
        Card
    },
    props: {
        trophies: {
            type: Array,
            required: true
        }
    }
}
</script>